import { type PropsWithChildren } from 'react';

import { AuthRetailerChanelBanner, ChanelBanner } from '@debijenkorf/custom-brand-components';

import '@debijenkorf/custom-brand-components/style';

import styles from './ChanelLayout.module.scss';

import classNames from 'classnames';

type ChanelLayoutProps = {
  isRebrand?: boolean;
};

export const ChanelLayout = ({ children, isRebrand }: PropsWithChildren<ChanelLayoutProps>) => (
  <div
    className={classNames({
      'theme-chanel': !isRebrand,
      'theme-rebrand-chanel': isRebrand,
    })}
  >
    <a href="/merk/chanel" className={styles.Link}>
      <ChanelBanner />
    </a>
    {children}
    <a href="/merk/chanel" className={styles.Link}>
      <AuthRetailerChanelBanner />
    </a>
  </div>
);
